export const COLUMN_DEFAULT_WIDTH = 300;
export const COLUMN_DEFAULT_MIN_WIDTH = 100;
export const BULK_SELECTION_MODE = {
  ALL_ON_PAGE: 'all-on-page',
  ALL: 'all',
  NONE: 'none',
  PARTIAL: 'partial'
};